export const DIGITAL_WELL_BEING_PRODUCT_NAME = 'digital-well-being'
export const UNIT_ROUTE_PRODUCT_NAMES = [
  'elementary',
  'middle-school',
  DIGITAL_WELL_BEING_PRODUCT_NAME,
]

export const LESSONS_PROGRAM_CONFIG = {
  elementary: {
    instructorKey: 'K5SelDigital',
    activeSiteKey: 'elementaryActiveSiteId',
    sitePreferencesKey: 'k5SitePreferences',
  },
  'middle-school': {
    instructorKey: 'MspDigital',
    activeSiteKey: 'middleSchoolActiveSiteId',
    sitePreferencesKey: 'middleSchoolSitePreferences',
  },
  [DIGITAL_WELL_BEING_PRODUCT_NAME]: {
    instructorKey: 'Dwb',
    activeSiteKey: 'digitalWellBeingActiveSiteId',
  },
}
